import type { PracticeLabelKeys } from "consts";

/** Translated label for a practice id; `notSet` when there is no id, the raw id when it has no label. */
export const translatePracticeLabel = (t: (key: string) => string, labels: PracticeLabelKeys, id: string | null | undefined, notSet: string): string => {
  if (!id) return notSet;
  const key = labels[id];
  return key ? t(key) : id;
};
